module.exports = __webpack_public_path__ + "static/media/baking-course.6c920e2c.webp";